export function generateSlug(title: string, id: string): string {
  // Convert title to slug format (lowercase, replace spaces with hyphens, remove special chars)
  const baseSlug = title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

  // Append the first 8 chars of the ID for uniqueness
  return `${baseSlug}-${id.slice(0, 8)}`;
}
